import {graphql, useFragment} from 'react-relay'

import {LABELS} from '../constants/labels'
import type {MarkdownLastEditedBy$key} from './__generated__/MarkdownLastEditedBy.graphql'
import styles from './MarkdownLastEditedBy.module.css'

type MarkdownLastEditedByProps = {
  editInformation?: MarkdownLastEditedBy$key
}

export function MarkdownLastEditedBy({editInformation}: MarkdownLastEditedByProps) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment MarkdownLastEditedBy on Comment {
        viewerCanReadUserContentEdits
        lastUserContentEdit {
          editor {
            # eslint-disable-next-line relay/unused-fields -- needed to preserve persisted query hash
            url
            login
          }
        }
      }
    `,
    editInformation,
  )

  if (!data || !data.viewerCanReadUserContentEdits || !data.lastUserContentEdit || !data.lastUserContentEdit.editor) {
    return null
  }

  const {login} = data.lastUserContentEdit.editor

  return (
    <span className={styles.lastEditInfoContainer}>
      {`${LABELS.editHistory.editedBy} `}
      <span className={styles.editorLogin}>{login}</span>
    </span>
  )
}
